module.exports = __webpack_public_path__ + "img/gnzs13.a15c7d5b.png";